import { Component, Input, ViewContainerRef, TemplateRef } from '@angular/core';
import { User } from '../../models/user/user-model';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { UserService } from '../../services/user/user.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { RoleService } from '../../services/role/role.service';
import { StateService } from '../../services/state/state.service';
import { CountryService } from '../../services/country/country.service';

import { Role } from '../../models/shared/role.model';
import { Country } from '../../models/country/country-model';
import { State } from '../../models/state/state-model';
import { RolePermissionService } from '../../services/role/role-permission.service';

@Component({
    selector: 'app-user-edit',
    templateUrl: './user-edit.component.html',
    styleUrls: ['./user-edit.component.css']
})
/** user-edit component*/
export class UserEditComponent {

  userModel = new User();
  userID: string;
  errorMessage: any;

  roleList: Role[] = [];
  countryList: Country[] = [];
  stateList: State[] = []
  isSubmitted = false;
  maxDate: Date;

    /** user-edit ctor */
  constructor(private readonly userService: UserService,
    private readonly roleService: RoleService,
    private readonly countryService: CountryService,
    private readonly stateService: StateService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly rolePermissionService: RolePermissionService,
    public toastr: ToastsManager, private readonly router: Router, vcr: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vcr);




    this.rolePermissionService.GetRolePermissions("user").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0) {
            this.maxDate = new Date();
            this.maxDate.setDate(this.maxDate.getDate());
            this.userModel.roleID = "";
            this.userModel.countryID = "";
            this.userModel.stateID = "";
            this.GetCountries();
            this.GetRoles();

            this.activatedRoute.params.subscribe((params: Params) => {
              this.userID = params['id'];
            });
          }
          else {
            this.router.navigate(["/users"]);
          }
        }
        else {
          this.router.navigate(["/users"]);
        }
      }
    )
  }

  GetUser(userid: string) {
    this.userService.getUser(userid).subscribe(
      data => {
        this.userModel = data;

        if (this.userModel.countryID) {
          this.GetStatesByCountry({
            target: {
              value: this.userModel.countryID
            }
          });
        }
        else {
          this.userModel.countryID = "";
        }

        if (this.userModel.roleID == null) {
          this.userModel.roleID = "";
        }

        this.userModel.dateOfBirth = new Date(this.userModel.dateOfBirth);  
      }
    )
  }

  GetRoles() {
    this.roleService.GetActiveRoles().subscribe(
      data => {
        this.roleList = data;
      });
  }

  GetStatesByCountry($event) {
    this.stateService.getStateByCountryId($event.target.value).subscribe(
      data => {
        this.stateList = data;

        if (this.userModel.stateID == null || this.userModel.stateID == "") {
          this.userModel.stateID = "";
        }
      });
  }

  GetCountries() {
    this.countryService.getCountries().subscribe(
      data => {
        this.countryList = data;
        this.GetUser(this.userID);
      });
  }

  ngSubmit() {
    this.isSubmitted = true;
    
    this.userService.updateUser(this.userModel).subscribe(result => {
      if (result) {
        this.toastr.success('User has been updated', 'Success');

        setTimeout(() => {
          this.router.navigate(["/users"]);
        }, 2000);
      }
      else {
        this.toastr.error('Error occurred. Please try again', 'Error');
        this.isSubmitted = false;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/user-components/user-edit/user-edit.component.ts